import React from "react";

import ProductPageTemplate from "../../components/global/layout/ProductPageTemplate";
import { scheduler } from "../../constants/productPageData";

const SchedulerPage = ({ location }) => {
    return (
        <ProductPageTemplate
            page={scheduler}
            theme="blue"
            location={location}
        />
    )
}

export default SchedulerPage